import { invariant } from '@app/utils/invariant'
import { PriceInputValue } from '@app/utils/PriceInputValue'
import { DEFAULT_CURRENCY } from '@app/utils/printCurrency'

import { profileCurrencySelector } from '@app/store/selectors/profile'
import { getCurrencyRatesForCode } from '@app/store/slices/currency_rates'
import { createThunk } from '@app/store/thunk'

export function getEmptyPriceInputValue() {
  return createThunk((_dispath, getState) => {
    return PriceInputValue.empty().setCurrency(profileCurrencySelector(getState()))
  })
}

export function compareCurrencies(a: PriceInputValue, b: PriceInputValue) {
  return createThunk(async dispatch => {
    if (a.currency === b.currency) {
      return compare(a.floatValue, b.floatValue)
    }
    const [an, bn] = await Promise.all([dispatch(toBaseCurrency(a)), dispatch(toBaseCurrency(b))])
    return compare(an, bn)
  })
}

function toBaseCurrency(a: PriceInputValue) {
  return createThunk(async dispatch => {
    if (a.currency === DEFAULT_CURRENCY) return a.floatValue
    const rates = await dispatch(getCurrencyRatesForCode(DEFAULT_CURRENCY))
    const rate = rates.find(c => c.attributes.from === a.currency) ?? invariant(new Error(`Cannot find rate from ${a.currency} to ${DEFAULT_CURRENCY}`))
    return a.floatValue * rate.attributes.rate
  })
}

function compare(a: number, b: number) {
  if (a === b) return 0
  return a > b ? 1 : -1
}
